import { render, staticRenderFns } from "./CuentaCobrarYPagarNuevo.vue?vue&type=template&id=5c12aa90&"
import script from "./CuentaCobrarYPagarNuevo.vue?vue&type=script&lang=js&"
export * from "./CuentaCobrarYPagarNuevo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports